import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, FormControl, InputLabel, Select, MenuItem, Box, Typography, CircularProgress,  } from '@mui/material';
import { Build as InstallerIcon } from '@mui/icons-material';
import { toast } from 'react-toastify';
import client from '../api/client';

const themeColors = {
  dark: '#1a1a2e',
  gold: '#d4af37',
  goldLight: '#f4e4bc',
};

const SendToInstallerDialog = ({ open, onClose, order, onSuccess }) => {
  const [installers, setInstallers] = useState([]);
  const [selectedInstaller, setSelectedInstaller] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open) {
      fetchInstallers();
    }
  }, [open]);

  const fetchInstallers = async () => {
    setLoading(true);
    try {
      const response = await client.get('/orders/installers/');
      setInstallers(response.data);
    } catch (error) {
      toast.error('خطا در دریافت لیست نصاب‌ها');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (!selectedInstaller) {
      toast.error('لطفاً یک نصاب انتخاب کنید');
      return;
    }

    setSubmitting(true);
    try {
      await client.post(`/orders/${order.id}/send-to-installer/`, {
        installer_id: selectedInstaller,
      });
      toast.success('سفارش به نصاب ارسال شد');
      onSuccess();
      handleClose();
    } catch (error) {
      toast.error(error.response?.data?.error || 'خطا در ارسال به نصاب');
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    setSelectedInstaller('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ bgcolor: themeColors.dark, color: themeColors.gold }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <InstallerIcon />
          <Typography variant="h6">انتخاب نصاب</Typography>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ pt: 3 }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
            <CircularProgress sx={{ color: themeColors.gold }} />
          </Box>
        ) : installers.length === 0 ? (
          <Typography color="text.secondary" align="center" sx={{ py: 2 }}>
            هنوز نصابی ثبت نشده است.
            <br />
            ابتدا از منوی نصاب‌ها، یک نصاب اضافه کنید.
          </Typography>
        ) : (
          <FormControl fullWidth sx={{ mt: 1 }}>
            <InputLabel>نصاب</InputLabel>
            <Select
              value={selectedInstaller}
              onChange={(e) => setSelectedInstaller(e.target.value)}
              label="نصاب"
            >
              {installers.map((installer) => (
                <MenuItem key={installer.id} value={installer.id}>
                  {installer.full_name} - {installer.mobile}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={handleClose} disabled={submitting}>
          انصراف
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={submitting || loading || installers.length === 0 || !selectedInstaller}
          sx={{
            bgcolor: themeColors.gold,
            color: themeColors.dark,
            '&:hover': { bgcolor: themeColors.goldLight },
          }}
        >
          {submitting ? <CircularProgress size={24} /> : 'ارسال به نصاب'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SendToInstallerDialog;
